module.exports = __webpack_public_path__ + "static/contact-0afc59c27b67f5ad556f98eaa41f51fa.webp";